// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-1":"350px","breakpoint-2":"600px","media-1":"(max-width: 350px)","media-2":"(max-width: 600px)","media-3":"(min-width: 600px)"};